import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { DataSeries } from '@next/core-lib/models';

import { Flock, FlockWeekChartFilters, WeekRegistrationKPIItem } from '../../models/flock.model';

export interface FlockOverviewWeekKpiChartInputData extends AbstractDialogData {
  kpi: WeekRegistrationKPIItem;
  flock: Flock;
  flockWeekDataSeries: DataSeries<number, number>;
  breedersReferenceBenchmarks: DataSeries<number, number>;
  porphyrioBenchmarks: DataSeries<number, number>;
  otherFlockWeekDataSeries: DataSeries<number, number>;
  otherFlockName: string;
  flockWeekChartFilters: FlockWeekChartFilters;
}

@Component({
  selector: 'app-flock-overview-week-kpi-chart',
  templateUrl: './flock-overview-week-kpi-chart.component.html',
  styleUrls: ['./flock-overview-week-kpi-chart.component.scss'],
  standalone: false,
})
export class FlockOverviewWeekKpiChartComponent extends AbstractDialog<void> implements OnInit {
  flockData: DataSeries<number, number>;
  breedersReferenceBenchmarkData: DataSeries<number, number> = null;
  porphyrioBenchmarkData: DataSeries<number, number> = null;
  otherFlockData: DataSeries<number, number>;
  otherFlockName: string;
  kpi: WeekRegistrationKPIItem = null;

  anyDataSourceIsSelected: boolean;
  allSelectedDataSourcesContainsData: boolean;
  dataSourcesWithoutDataDescription: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FlockOverviewWeekKpiChartInputData,
    protected mdDialogRef: MatDialogRef<
      FlockOverviewWeekKpiChartComponent,
      AbstractDialogResultData<void>
    >,
    @Inject(LocaleService) private localeService: LocaleService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.kpi !== undefined && this.data.kpi !== null) {
      // Set title and translations.
      const kpiLabel = this.localeService.translate(
        `flock-overview.week-registrations.kpis.${this.data.kpi.name}`,
      );
      this.data.title =
        this.localeService.translate(`flock-overview.week-registrations.benchmark.title`) +
        ` ${kpiLabel}`;
    }

    this.flockData = this.data.flockWeekDataSeries;
    this.breedersReferenceBenchmarkData = this.data.breedersReferenceBenchmarks;
    this.porphyrioBenchmarkData = this.data.porphyrioBenchmarks;
    this.otherFlockData = this.data.otherFlockWeekDataSeries;
    this.otherFlockName = this.data.otherFlockName;
    this.kpi = this.data.kpi;

    this.applyDataSourceChecks();
  }

  private applyDataSourceChecks(): void {
    const {
      showCurrentFlock,
      showBreedersReferenceBenchmark,
      showPorphyrioBenchmark,
      showOtherFlock,
    } = this.data.flockWeekChartFilters;

    this.anyDataSourceIsSelected =
      showCurrentFlock ||
      showBreedersReferenceBenchmark ||
      showPorphyrioBenchmark ||
      showOtherFlock;
    this.allSelectedDataSourcesContainsData =
      (!showCurrentFlock || !!this.flockData) &&
      (!showBreedersReferenceBenchmark || !!this.breedersReferenceBenchmarkData) &&
      (!showPorphyrioBenchmark || !!this.porphyrioBenchmarkData) &&
      (!showOtherFlock || !!this.otherFlockData);

    if (this.anyDataSourceIsSelected && !this.allSelectedDataSourcesContainsData) {
      this.dataSourcesWithoutDataDescription = this.localeService.translate(
        'flock-overview.week-registrations.benchmark.error.no-data-description',
      );
    }
  }
}
